<template>
    <b-modal
        title="Log In"
        visible
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        header-bg-variant="dark"
        header-text-variant="light"
    >
        <b-container>
            <LoginForm @login="attemptLogin" />
        </b-container>
    </b-modal>
</template>

<script>
import LoginForm from '@/components/LoginForm';
import { AlertManager } from '$Shared/@arc/vue-arc-alerts';
import { Log } from '$Shared/@arc/vue-arc';
import { mapActions } from 'vuex';

export default {
    name: 'Login',
    layout: 'GuestLayout',

    components: {
        LoginForm
    },

    methods: {
        ...mapActions({
            login: 'auth/login',
        }),

        async attemptLogin(credentials) {
            try {
                await this.login(credentials);
                this.$router.push({ name: process.env.VUE_APP_USER_HOME_ROUTE });
            } catch (arcAlert) {
                Log.error(arcAlert, 'COMPONENT->Login Error caught: ');
                AlertManager.showErr(arcAlert);
            }
        },
    }
};
</script>

